module.exports = __webpack_public_path__ + "img/youban.prt.a066842d.jpg";